import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.nav ``;
const Button = styled.button `
  ${ButtonReset};
  ${transition('background-size, border-color, color', 0.2)};

  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  font-size: ${fluid(16, 18)};
  line-height: 1em;
  width: ${fluid(40, 60)};
  height: ${fluid(40, 60)};
  padding: 0;
  margin: 0;
  border: 1px solid var(--colourBorder);
  background: var(--colourBg);
  background-image: linear-gradient(to right, var(--colourBgActive), var(--colourBgActive));
  background-repeat: no-repeat;
  background-size: 0% 100%;
  color: var(--colourText);

  > svg {
    height: ${fluid(16, 20)};
  }

  &[aria-label='Previous'] {
    [data-site='mep'] & {
      border-radius: 50% 0 0 50%;
    }

    svg {
      transform: rotate(-90deg);
    }
  }

  &[aria-label='Next'] {
    [data-site='mep'] & {
      border-radius: 0 50% 50% 0;
    }

    svg {
      transform: rotate(90deg);
    }
  }

  &:disabled {
    @media ${until(Device.TabletLarge)} {
      background-color: var(--colourBgDisabled);
      border-color: var(--colourBorderDisabled);
    }

    @media ${from(Device.TabletLarge)} {
      opacity: 0.66;
    }
  }

  &.focus-ring {
    outline: var(--colourText);
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
  }

  &:not(:disabled) {
    &.focus-ring,
    &:hover {
      color: var(--colourTextActive);
      border-color: var(--colourBorderActive);
      background-size: 100% 100%;
    }

    /* Mobile click styles - button should mimic press */
    @media ${until(Device.TabletLarge)} {
      ${transition('transform, background-size, border-color, color', 0.15)};
      &:active {
        transform: translateY(1.5px);
      }
    }
  }

  /* Colour settings */

  --colourBg: ${brand.global.red};
  --colourBgActive: ${brand.global.red};
  --colourBorder: ${brand.global.red};
  --colourBorderActive: ${brand.global.red};
  --colourTextActive: ${brand.global.white};
  --colourText: ${brand.global.white};

  @media ${from(Device.TabletLarge)} {
    --colourText: ${brand.global.red};
    --colourBg: 'transparent';
  }

  [data-site='ess'] & {
    --colourBgDisabled: ${brand.ess.secondary.midGrey};
    --colourBorderDisabled: ${brand.ess.secondary.midGrey};
  }

  [data-site='mep'] & {
    --colourBgDisabled: ${brand.mep.secondary.darkestGrey};
    --colourBorderDisabled: ${brand.mep.secondary.darkestGrey};
  }
`;
const ControlsStyles = {
    Container,
    Button,
};
export default ControlsStyles;
